"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationCurrencyCodeMapper = exports.getCurrencyFromLocation = exports.currencySymbols = exports.currencyOptions = exports.operationalCurrencyCodes = exports.currencyCodes = void 0;
exports.currencyCodes = ['GBP', 'USD', 'AUD', 'EUR', 'CAD'];
exports.operationalCurrencyCodes = ['GBP', 'USD'];
exports.currencyOptions = [
    { label: 'GBP', value: 'GBP' },
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'AUD', value: 'AUD' },
    { label: 'CAD', value: 'CAD' },
];
exports.currencySymbols = {
    GBP: '£',
    USD: '$',
    EUR: '€',
    AUD: 'A$',
    CAD: 'CA$',
};
const getCurrencyFromLocation = (location) => exports.locationCurrencyCodeMapper[location];
exports.getCurrencyFromLocation = getCurrencyFromLocation;
exports.locationCurrencyCodeMapper = {
    AU: 'AUD',
    GB: 'GBP',
    EU: 'EUR',
    US: 'USD',
    CA: 'CAD',
    AD: 'USD',
    AE: 'USD',
    AF: 'USD',
    AG: 'USD',
    AL: 'USD',
    AM: 'USD',
    AO: 'USD',
    AQ: 'USD',
    AR: 'USD',
    AW: 'USD',
    AZ: 'USD',
    BA: 'USD',
    BB: 'USD',
    BD: 'USD',
    BF: 'USD',
    BH: 'USD',
    BI: 'USD',
    BJ: 'USD',
    BM: 'USD',
    BN: 'USD',
    BO: 'USD',
    BQ: 'USD',
    BR: 'USD',
    BS: 'USD',
    BT: 'USD',
    BW: 'USD',
    BY: 'USD',
    BZ: 'USD',
    CD: 'USD',
    CI: 'USD',
    CL: 'USD',
    CM: 'USD',
    CN: 'USD',
    CO: 'USD',
    CR: 'USD',
    CU: 'USD',
    CV: 'USD',
    CW: 'USD',
    DO: 'USD',
    DZ: 'USD',
    EC: 'USD',
    EE: 'USD',
    EG: 'USD',
    EH: 'USD',
    ET: 'USD',
    FJ: 'USD',
    FK: 'USD',
    FM: 'USD',
    FO: 'USD',
    GA: 'USD',
    GD: 'USD',
    GE: 'USD',
    GG: 'USD',
    GH: 'USD',
    GI: 'USD',
    GM: 'USD',
    GP: 'USD',
    GQ: 'USD',
    GR: 'USD',
    GT: 'USD',
    GU: 'USD',
    GY: 'USD',
    HK: 'USD',
    HN: 'USD',
    HR: 'USD',
    HT: 'USD',
    ID: 'USD',
    IL: 'USD',
    IN: 'USD',
    IQ: 'USD',
    IR: 'USD',
    IS: 'USD',
    JE: 'USD',
    JM: 'USD',
    JO: 'USD',
    JP: 'USD',
    KE: 'USD',
    KG: 'USD',
    KH: 'USD',
    KN: 'USD',
    KR: 'USD',
    KW: 'USD',
    KY: 'USD',
    KZ: 'USD',
    LA: 'USD',
    LB: 'USD',
    LC: 'USD',
    LI: 'USD',
    LK: 'USD',
    LS: 'USD',
    LT: 'USD',
    LU: 'USD',
    LV: 'USD',
    LY: 'USD',
    MA: 'USD',
    MC: 'USD',
    MD: 'USD',
    ME: 'USD',
    MG: 'USD',
    MK: 'USD',
    ML: 'USD',
    MM: 'USD',
    MN: 'USD',
    MO: 'USD',
    MQ: 'USD',
    MR: 'USD',
    MT: 'USD',
    MU: 'USD',
    MV: 'USD',
    MW: 'USD',
    MX: 'USD',
    MY: 'USD',
    MZ: 'USD',
    NA: 'USD',
    NC: 'USD',
    NE: 'USD',
    NF: 'USD',
    NG: 'USD',
    NI: 'USD',
    NP: 'USD',
    NZ: 'USD',
    OM: 'USD',
    PA: 'USD',
    PE: 'USD',
    PF: 'USD',
    PG: 'USD',
    PH: 'USD',
    PK: 'USD',
    PR: 'USD',
    PS: 'USD',
    PY: 'USD',
    QA: 'USD',
    RE: 'USD',
    RS: 'USD',
    RU: 'USD',
    RW: 'USD',
    SA: 'USD',
    SC: 'USD',
    SD: 'USD',
    SG: 'USD',
    SI: 'USD',
    SK: 'USD',
    SL: 'USD',
    SM: 'USD',
    SN: 'USD',
    SO: 'USD',
    SR: 'USD',
    SS: 'USD',
    SV: 'USD',
    SY: 'USD',
    SZ: 'USD',
    TD: 'USD',
    TG: 'USD',
    TH: 'USD',
    TJ: 'USD',
    TL: 'USD',
    TM: 'USD',
    TN: 'USD',
    TR: 'USD',
    TT: 'USD',
    TV: 'USD',
    TW: 'USD',
    TZ: 'USD',
    UA: 'USD',
    UG: 'USD',
    UY: 'USD',
    UZ: 'USD',
    VC: 'USD',
    VE: 'USD',
    VG: 'USD',
    VI: 'USD',
    VN: 'USD',
    VU: 'USD',
    XK: 'USD',
    YE: 'USD',
    YT: 'USD',
    ZA: 'USD',
    ZM: 'USD',
    ZW: 'USD',
    AT: 'EUR',
    BE: 'EUR',
    DK: 'EUR',
    FI: 'EUR',
    FR: 'EUR',
    DE: 'EUR',
    IT: 'EUR',
    IE: 'EUR',
    NL: 'EUR',
    NO: 'EUR',
    PL: 'EUR',
    ES: 'EUR',
    SE: 'EUR',
    CH: 'EUR',
    CZ: 'EUR',
    HU: 'EUR',
    CY: 'EUR',
    PT: 'EUR',
    BG: 'EUR',
    RO: 'EUR',
};
//# sourceMappingURL=data:application/json;base64,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